module.exports = "/static/media/lineto-circular-medium.8f516c4c.eot";